import { assessmentsConstants } from '../../_constants';
import swal from 'sweetalert2';

const initialState = { respondentsAssessmentLoading: true, data: '', error: false };

export function respondentsAssessmentReducer(state = initialState, action) {

    switch (action.type) {
        case assessmentsConstants.REQUEST_RESPONDENTS_ASSESSMENT:
            return {
                respondentsAssessmentLoading: true,
                data: '',
                error: false
            };
        case assessmentsConstants.RECEIVE_RESPONDENTS_ASSESSMENT:
            return {
                respondentsAssessmentLoading: false,
                data: action.respondentsAssessment,
                error: false
            };
        case assessmentsConstants.RESPONDENTS_ASSESSMENT_ERROR:
        swal({
            text: action.error.response.data.message,
            type: 'error',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          })
    
            return {
                respondentsAssessmentLoading: false,
                data: action.error,
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/assessments/respondentsAssessment.reducer.js